import UniqFinalPackingListRoutes from "./uniq_final_packing_list";
import BasicContainerExportRoutes from "./basic_container_export";
import QueryContainerExportRoutes from "./query_container_export";

export default [
  ...UniqFinalPackingListRoutes,
  ...BasicContainerExportRoutes,
  ...QueryContainerExportRoutes
];
